import { Col } from '@mlc/web-ui-toolkit';
import styled from 'styled-components';
import { ScreenSize } from '../../../enums';

export const View = styled(Col)`
	@media (max-width: ${ScreenSize.small}) {
		flex: 0 0 100%;
		margin-bottom: 20px;
		max-width: 100%;
	}
`;

export const Details = styled(Col)`
	@media (max-width: ${ScreenSize.small}) {
		flex: 0 0 100%;
		max-width: 100%;
	}
`;
